import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from '../../stores/redux';

const getState = (state: RootState): RootState => state;

const getApolloSessionState = createSelector(
  getState,
  (state: RootState) => state.apolloSession,
);

export const getApolloSessionDetails = (state: RootState) =>
  state.apolloSession;

/**
 * Is this is a V2 call started from OG?
 */
export const getIsStartedFromOG = (state: RootState) =>
  typeof state.apolloSession.patientId === 'string';

export const getUserId = (state: RootState) => state.apolloSession.userId;

export const getJoinedParticipantsIds = createSelector(
  getApolloSessionState,
  (state) => state.joinedParticipantsIds ?? [],
);

export const getStartCallTime = (state: RootState) =>
  state.apolloSession.startCallTime as number;

export const getCurrentRoomId = (state: RootState) =>
  Boolean(state.apolloSession.roomId) ? state.apolloSession.roomId : undefined;

export const getRoomById = createSelector(
  getApolloSessionState,
  (_state: unknown, roomId: string | undefined) => roomId,
  (state, roomId) => state.rooms.find((room) => room.id === roomId),
);

/**
 * Call init related
 */
export const getIsAudioCall = (state: RootState) =>
  state.apolloSession.isAudioCall ?? false;

/**
 * Institution
 */
export const getInstitutionsMembershipsIds = (state: RootState) =>
  state.apolloSession.institutionsMembershipsIds;

export const getInstitutionId = (state: RootState) =>
  state.apolloSession.institutionId;
